<script>
import Vue from 'vue'
import Vuex from 'vuex'

import actions from './actions'
import mutations from './mutations'
import getters from './getters'

import Auth from './modules/auth/store'
import Booking from './modules/booking/store'
import Room from './modules/room/store'

import TimeUtils from './../utils/TimeUtils';

Vue.use(Vuex)

const state = {
  selectedRoomId: undefined,
  selectedDate: TimeUtils.currentDate(),
}

export default new Vuex.Store({
  state,
  actions,
  mutations,
  getters,
  modules: {
    Auth,
    Booking,
    Room
  }
})

// this.$store.state.error.photoError;
</script>



// WEBPACK FOOTER //
// src/store/store.vue